{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) MFC Worx
    Address:            Wiefelstederstr. 4a, 26160 Bad Zwischenahn, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             michael.ellermann@mfc-worx.com
    HTTP:               mfc-worx.com

    UnitName:           wxBaseClassWebTools
    Folder:             ../..
    Created:            Tue 06.06.2023 13:14
    Author:             Michael Ellermann

    ShortDescription:   Web Tools für alles mögliche :-)

    Description:

**                                                                                                **
****************************************************************************************************
MnemoREM}

unit wxBaseClassWebTools;

interface

uses
  System.SysUtils,
  System.Classes,
  System.Rtti,
  System.TypInfo,
  System.StrUtils,
  


  JS,          // Gets us TJS* types (included by default)
  jsdelphisystem,

//  JclDebug,
  Web;


type
  TMsgHndSeverityLevel = (slSQLDuration, slDebug, slTelegram, slWarning, slError, slFatalError, slVerbose);

  TMsgHndLogLevel = (llDebug, llTelegram, llWarning, llError, llVerbose);

  TMsgHndDestinationType = (dtConsole, dtDatabase);

  TwxBaseClassLogTool = class(TComponent)
  strict private
    function StrPadLeft(const AValue: string; const ALength: Integer; const APattern: Char): string;
  private
    FDestinationType: TMsgHndDestinationType;
    FLogLevel: TMsgHndLogLevel;
    function GetWorkingSetSize: Integer;
    function LogToConsole(const AMsg: string; const ASeverityLevel: TMsgHndSeverityLevel; ALogLevel: TMsgHndLogLevel): string;
    function LogToDataBase(const AMsg: string; const ASeverityLevel: TMsgHndSeverityLevel; ALogLevel: TMsgHndLogLevel): string;
  public
    constructor Create;
    destructor Destroy; override;
    function Write(AMsg: string; ASeverityLevel: TMsgHndSeverityLevel; AEventID: integer = 0): string; overload;

  published
    function DebugInfo(AShort: Boolean = false; ADebugLevel: Integer = 3): string;
    property DestinationType: TMsgHndDestinationType read FDestinationType write FDestinationType default dtConsole;
    property LogLevel: TMsgHndLogLevel read FLogLevel write FLogLevel default llDebug;
  end;

function wxBaseWriteLog: TwxBaseClassLogTool;


implementation


function wxBaseWriteLog: TwxBaseClassLogTool;
begin
  if not Assigned(Result) then
  begin
    Result := TwxBaseClassLogTool.Create;
  end;
end;

constructor TwxBaseClassLogTool.Create;
begin
//  inherited;
end;

destructor TwxBaseClassLogTool.Destroy;
begin
  inherited;
end;

function TwxBaseClassLogTool.DebugInfo(AShort: Boolean = false; ADebugLevel: Integer = 3): string;
  var LProcedure : string;
  var LZeile      : string;
  var LDatei      : string;
  var LMemoryInKB : Integer;
  begin
    // Debug-Informationen schreiben
    Result := '[] ';
    try
//      LProcedure := ProcByLevel(ADebuglevel);
//      LZeile     := StrPadLeft(IntToStr(LineByLevel(ADebuglevel)), 4, '0');
//      LDatei     := ExtractFileName(FileByLevel(ADebuglevel));
      if (Trim(LProcedure) <> '') then
      begin
        if (AShort) then
        begin
          Result := '[' + LProcedure + ':' + LZeile + '] ';
        end else
        begin
          LMemoryInKB := GetWorkingSetSize;
          Result := '[ ' + LDatei + ':' + LZeile + ', ' + LProcedure + ', RAM = ' + IntToStr(LMemoryInKB) + ' kB ]' ;
        end;
      end;
    except
    end;
end;

function TwxBaseClassLogTool.GetWorkingSetSize: Integer;
begin
  result := -1;
end;

function TwxBaseClassLogTool.LogToConsole(const AMsg: string; const ASeverityLevel: TMsgHndSeverityLevel; ALogLevel:
    TMsgHndLogLevel): string;
begin
  Result := Self.DebugInfo + AMsg;
  case ASeverityLevel of
    slVerbose: console.Log(Self.DebugInfo + AMsg);
    slDebug  : console.Log(Self.DebugInfo + AMsg);
    slError, slFatalError: console.error(Self.DebugInfo + AMsg);
//    slWarning:
//      begin
//        Self.LogFileDebug.Write(Self.DebugInfo + AMsg);
//        Self.LogFileWarning.Write(Self.DebugInfo + AMsg);
//      end;
//    slError, slFatalError:
//      begin
//        Self.LogFileDebug.Write(Self.DebugInfo + AMsg);
//        Self.LogFileError.Write(Self.DebugInfo + AMsg);
//        if (ASeverityLevel=slFatalError) then
//        begin
//          Self.LogFileDebug.Write('Application will be terminated now!');
//          Self.LogFileError.Write('Application will be terminated now!');
//        end;
//      end;
//    slTelegram:
    slSQLDuration         : console.info(Self.DebugInfo + AMsg);
  end;
end;

function TwxBaseClassLogTool.LogToDataBase(const AMsg: string; const ASeverityLevel: TMsgHndSeverityLevel; ALogLevel:
    TMsgHndLogLevel): string;
begin
  Result := '';
end;

function TwxBaseClassLogTool.StrPadLeft(const AValue: string; const ALength: Integer; const APattern: Char): string;
begin
  Result := AValue;
  while length(Result) < ALength do
  begin
    Result := APattern + Result;
  end;
end;

function TwxBaseClassLogTool.Write(AMsg: string; ASeverityLevel: TMsgHndSeverityLevel; AEventID: integer = 0): string;
begin
  Result := AMsg;

  case ASeverityLevel of
    slSQLDuration:
    begin
      if (Self.LogLevel = llVerbose) or
         (Self.LogLevel = llDebug) then
      begin
        if (Self.DestinationType = dtConsole) then
        begin
          Result := Self.LogToConsole(AMsg, ASeverityLevel, Self.LogLevel);
        end else
        begin
          Result := Self.LogToDatabase(AMsg, ASeverityLevel, Self.LogLevel);
        end;
      end;
    end;

    slDebug:
    begin
      if (Self.LogLevel = llVerbose) or
         (Self.LogLevel = llDebug) then
      begin
        if (Self.DestinationType = dtConsole) then
        begin
          Result := Self.LogToConsole(AMsg,ASeverityLevel,Self.LogLevel);
        end else
        begin
          Result := Self.LogToDatabase(AMsg, ASeverityLevel, Self.LogLevel);
        end;
      end;
    end;

    slTelegram:
    begin
      if (Self.LogLevel = llVerbose) or
         (Self.LogLevel = llDebug) or
         (Self.LogLevel = llTelegram) then
      begin
        if (Self.DestinationType = dtConsole) then
        begin
          Result := Self.LogToConsole(AMsg,ASeverityLevel,Self.LogLevel);
        end else
        begin
          Result := Self.LogToDatabase(AMsg, ASeverityLevel, Self.LogLevel);
        end;
      end;
    end;

    slWarning:
    begin
      if (Self.LogLevel = llVerbose) or
         (Self.LogLevel = llDebug) or
         (Self.LogLevel = llTelegram) or
         (Self.LogLevel = llWarning) then
      begin
        if (Self.DestinationType = dtConsole) then
        begin
          Result := Self.LogToConsole(AMsg,ASeverityLevel,Self.LogLevel);
        end else
        begin
          Result := Self.LogToDatabase(AMsg, ASeverityLevel, Self.LogLevel);
        end;
      end;
    end;

    slError, slFatalError:
    begin
      if (Self.DestinationType = dtConsole) then
      begin
        Result := Self.LogToConsole(AMsg,ASeverityLevel,Self.LogLevel);
      end else
      begin
        Result := Self.LogToDatabase(AMsg, ASeverityLevel, Self.LogLevel);
      end;

      if (ASeverityLevel=slFatalError) then
      begin
        // Bei FatalError eine noch zu definierende System Message werfen
        { TODO -oMEL -cNORMAL : Hier muss noch was gemacht werden in Richtung Protokollierung }
      end;
    end;

    slVerbose:
    begin
      if (Self.LogLevel = llVerbose) then
      begin
        if (Self.DestinationType = dtConsole) then
        begin
          Result := Self.LogToConsole(AMsg,ASeverityLevel,Self.LogLevel);
        end else
        begin
          Result := Self.LogToDatabase(AMsg, ASeverityLevel, Self.LogLevel);
        end;
      end;
    end;
  end;
end;

end.
